import { CopyAllButtonByExcelGenerator } from 'components/shared/CopyAllButton/CopyAllButton';
import { formatGridToClipboard } from 'components/shared/ReadOnlyGrid/GridUtils';
import { BasicGenericGrid } from 'components/shared/Sensitivity/Greeks/basicGenericTable';
import type { IntlKey } from 'locales';
import type { AnalyticCategoryActions, WorkspaceAnalyticCategory } from 'models';
import { FC, useCallback, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';
import type { GenericTable } from 'state/quotes/details/details.model';

interface GenericProps {
  className?: string;
  data: GenericTable;
  precision: number;

  titleKey?: IntlKey;
  noDataMessageKey?: IntlKey;
  copyActionName: AnalyticCategoryActions[WorkspaceAnalyticCategory];
}

export const GenericGrid: FC<GenericProps> = ({
  data,
  precision,
  className,
  noDataMessageKey,
  titleKey,
  copyActionName,
}) => {
  const generateFormattedGrid = useCallback(() => formatGridToClipboard(data), [data]);
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  if (data === undefined && !!noDataMessageKey) {
    return <FormattedMessage id={noDataMessageKey} />;
  }
  return (
    <div className={className} data-e2e="greeks-card">
      {titleKey && (
        <h5 className="card-title py-2 text-secondary" data-e2e="greeks-card-title">
          <FormattedMessage id={titleKey} />
        </h5>
      )}
      <div className="table-responsive">
        <BasicGenericGrid
          data={data}
          precision={precision}
          tableClassName={'bg-lvl1 table-striped'}
          displayHeader={true}
          displayMultiColumn={false}
          e2e="generic-table"
        />
      </div>

      <CopyAllButtonByExcelGenerator
        className="float-end"
        generateExcelGrid={generateFormattedGrid}
        analyticsCategory={logAnalyticsCategory}
        analyticsAction={copyActionName}
      />
    </div>
  );
};
